import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'bookingTotal'
})
export class BookingTotalPipe implements PipeTransform {

  transform(booking: any): any {
    return moment.duration(new Date(booking.check_out).getTime() - new Date(booking.check_in).getTime(), 'milliseconds').asDays() * booking.payment_rate;
  }

}
